import { render, staticRenderFns } from "./PolicyContent.vue?vue&type=template&id=589f8f95&scoped=true&"
import script from "./PolicyContent.vue?vue&type=script&lang=js&"
export * from "./PolicyContent.vue?vue&type=script&lang=js&"
import style0 from "./PolicyContent.vue?vue&type=style&index=0&id=589f8f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f8f95",
  null
  
)

export default component.exports